var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-credit-card',{attrs:{"host-field-id":_vm.containerName,"title":'ת.ז.',"error-message":_vm.socialId.error,"focused":_vm.focused,"empty":_vm.socialId.isEmpty}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34d6cadc","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/responsive-pages/authenticated/subscription/components/credit-card-fields/SocialId.vue
// module id = null
// module chunks = 